<template>
  <div class="ErrorPage">
    <div class="pageText">
      <div class="text">权限不足请联系后台管理员</div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return {

    }
  },
  methods:{
    
  }
}
</script>  
<style lang="less" scoped>
  .ErrorPage{
    background: url("../assets/images/404.jpg") no-repeat;
    background-position: center;
    height: 100%;
    width: 100%;
    background-size: cover;
    position: fixed;
    .pageText{
      position: absolute;
      bottom: 200px;
      left: 50%;
      margin-left: -80px;
      text-align: center;
      color: #fff;
      font-size: 14px;
      .text{
        margin-bottom: 30px;
      }
      .btn{
        width: 160px;
        height: 40px;
      }
      .el-button--default{
        border-color:transparent;
      }
    }
  }
</style>


